const selectFn = () => {
  const select = $('.courses-data__select');
  const selectFake = $('.courses-data-nav__value');
  const listFake = $('.courses-data-nav__list');

  selectFake.on('click', () => {
    if (listFake.is(':hidden')) {
      listFake.stop().slideDown();
    } else {
      listFake.stop().slideUp();
    }
  });

  const listFakeItem = listFake.find('li');

  listFakeItem.on('click', function () {
    const times = $(this).data('times');
    const value = $(this).find('span').html();

    $('.courses-data-nav__value').find('small').html(`${times}x`);
    $('.courses-data-nav__value').find('span').html(value);

    select.val(times);
    listFake.slideUp();
  });
};

export default selectFn;



// WEBPACK FOOTER //
// /app/app/assets/javascripts/packs/courses/coursesSelect.js